<div class="pull-to-refresh-indicator"
  [style.transform]="'translateY(' + pullDistance + 'px)'"
  [class.active]="refreshing">
  <div class="spinner-container">
    @if (refreshing) {
      <p-progressSpinner
        strokeWidth="4"
      [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
    }
    @if (!refreshing) {
      <div class="pull-arrow"
        [style.opacity]="pullDistance / 80">
        <i class="pi pi-arrow-down"></i>
      </div>
    }
  </div>
</div>